import React from "react";
import { ICommand } from "Application";
import { Button } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import { Container, Footer, ButtonGroup, StyledDialog, Header, ModelBody } from "./AddStudent/OverTimeConfirmationPopup.styles";

export interface IProps {
    closeCommand: ICommand;
    confirmCommand: ICommand;
}

const ResetRotaConfirmationPopup: React.FC<IProps> = ({ closeCommand, confirmCommand }) => (
    <StyledDialog open={true}>
        <Header>
            Reset rota confirmation
            <CloseIcon onClick={closeCommand.execute} />
        </Header>
        <Container>
            <ModelBody>
                <span>This will permanently delete all assignments for this week.</span>
                <span>Are you sure you want to reset the rota?</span>
            </ModelBody>
            <Footer>
                <ButtonGroup>
                    <Button command={confirmCommand} displayName={"Reset"} paletteColor="primary" />
                    <Button command={closeCommand} displayName={"Cancel"} paletteColor="secondary" />
                </ButtonGroup>
            </Footer>
        </Container>
    </StyledDialog>
);

export default ResetRotaConfirmationPopup;
